// extracted by mini-css-extract-plugin
export default {"roundedDiv":"ProjectExampleImage_roundedDiv__+Hz5n","projectThumbnail":"ProjectExampleImage_projectThumbnail__o-I0t"};